import _classCallCheck from "/Users/jlake/sandbox/harbour/harbour-swap-web/node_modules/babel-preset-inferno-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var IEvents = function IEvents() {
  _classCallCheck(this, IEvents);
};